<template>
    <div>
      <div id="breadcrumbs">
        <div>
          <div style="display: flex;">
            <router-link to="/shared-drive/archived" :aria-label="$t('files.home')" :title="$t('files.home')">
              <i class="material-icons">folder</i>
            </router-link>
  
            <span v-for="(link, index) in bclist" :key="index">
              <span class="chevron"><i class="material-icons">keyboard_arrow_right</i></span>
              <router-link :to="link.url">{{ link.name }}</router-link>
            </span>
          </div>
          <div class="buttons" v-if="isMobile">
            <new-unit v-if="$route.hash === '' && permissions === 0"></new-unit>
            <manage-access v-if="showManageAccess && permissions === 0"></manage-access>
            <new-button v-if="user.perm.create && $route.hash !== '' && permissions === 0"></new-button>
            <upload-button v-if="user.perm.create && $route.hash !== '' && permissions === 0"></upload-button>
          </div>
        </div>
        <switch-button></switch-button>
      </div>
      <div v-if="!isEditor" class="contenedor-id">
        <div class="container-image">
          <p class="user-name">{{ this.userName }}</p>
        </div>
        <div class="iberbox-id">
          <h3>{{ $t('sharedDrive.yourIberboxID') }}</h3>
          <div class="id">
            <button @click="copy" :aria-label="$t('buttons.copy')" :title="$t('buttons.copy')" class="action button-copy" id="copy-button">
              <copy-icon size="1.5x" class="custom-class"></copy-icon>
              <span>{{ $t('buttons.copy') }}</span>
            </button>
            <div style="display: flex; align-items: center;">
              <info-icon style="margin-right: 5px; min-width: 18px; min-height: 18px;" size="1.5x" class="custom-class"></info-icon>
              <p v-html="$t('sharedDrive.contactsNeed')"></p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="error">
        <not-found v-if="error.message === '404'"></not-found>
        <forbidden v-else-if="error.message === '403'"></forbidden>
        <internal-error v-else></internal-error>
      </div>
      <editor v-else-if="isEditor"></editor>
      <sheet-editor v-else-if="isSheets"></sheet-editor>
      <docs-editor v-else-if="isDocs"></docs-editor>
      <preview v-else-if="isPreview"></preview>
      <listing-shared-drive :class="{ multiple }" v-else-if="!loading"></listing-shared-drive>
      <div v-else>
        <h2 class="message">
          <span>{{ $t('files.loading') }}</span>
        </h2>
      </div>
    </div>
  </template>
  
  <script>
  import Forbidden from './errors/403';
  import NotFound from './errors/404';
  import InternalError from './errors/500';
  import Preview from '@/components/files/Preview';
  import ListingSharedDrive from '@/components/files/ListingSharedDrive';
  import Editor from '@/components/files/Editor';
  const SheetEditor = () => import(/* webpackChunkName: "sheet-editor" */ '@/components/files/SheetEditor.vue');
  const DocsEditor = () => import(/* webpackChunkName: "docs-editor" */ '@/components/files/DocsEditor.vue');
  import SwitchButton from '@/components/buttons/SwitchView';
  import { files as api } from '@/api';
  import { mapGetters, mapState, mapMutations } from 'vuex';
  import { CopyIcon, InfoIcon } from 'vue-feather-icons';
  import ManageAccess from '@/components/buttons/ManageAccess';
  import UploadButton from '@/components/buttons/Upload';
  import NewButton from '@/components/buttons/New';
  import NewUnit from '@/components/buttons/NewUnit';
  
  export default {
    name: 'archived',
    components: {
      Forbidden,
      NotFound,
      InternalError,
      Preview,
      ListingSharedDrive,
      Editor,
      SheetEditor,
      DocsEditor,
      SwitchButton,
      CopyIcon,
      InfoIcon,
      ManageAccess,
      UploadButton,
      NewButton,
      NewUnit
    },
    computed: {
      ...mapGetters([
        'selectedCount',
        'isListing',
        'isEditor',
        'isSheets',
        'isDocs',
        'isFiles'
      ]),
      ...mapState([
        'req',
        'user',
        'userInfo',
        'reload',
        'multiple',
        'loading',
        'sortOrder',
        'isDelete',
        'isRename',
        'permissions',
        'accountInfo',
        'editorSaving',
      ]),
      userName() {
        return this.userInfo.firstname.substr(0, 1) + this.userInfo.lastname.substr(0, 1);
      },
      isPreview () {
        return !this.loading && !this.isEditor && !this.isSheets && !this.isDocs && !this.flag;
      },
      isMobile () {
        return window.innerWidth <= 768;
      },
      showManageAccess () {
        if (this.$route.hash !== '' && this.req.nodeType === Module.NodeType.SHARED_DRIVE_ROOT.value) {
          return true;
        } else {
          return false;
        }
      },
    },
    data: function () {
      return {
        error: null,
        bclist: [],
        sharedDrives: [],
        handleCuenta: '',
        flag: true
      };
    },
    created () {
      let thisComponent = this;
      let JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
        onActionFinish: function(action)
        {
          if (action.type === Module.ActionType.MANAGE_SHARED_DRIVES.value && action.node !== undefined && action.intValue !== 1) {
            if (thisComponent.$store.state.editorSaving) return;
            thisComponent.fetchData();
          } else {
            return;
          }
        }
      });
  
      this.interfaceObject = new JavaEventListenerClass();
      ibb.addActionListener(this.interfaceObject);
      this.fetchData();
    },
    watch: {
      '$route': function () {
        if (this.editorSaving) return;
        this.fetchData();
      },
      'reload': function () {
        if (this.editorSaving) return;
        this.fetchData();
      }
    },
    async mounted () {
      window.addEventListener('keydown', this.keyEvent);
      window.addEventListener('scroll', this.scroll);
    },
    beforeDestroy () {
      window.removeEventListener('keydown', this.keyEvent);
      window.removeEventListener('scroll', this.scroll);
      ibb.removeActionListener(this.interfaceObject);
    },
    destroyed () {
      this.$store.commit('updateRequest', {});
    },
    methods: {
      ...mapMutations([ 'setLoading' ]),
      async fetchData () {
        // Reset view information.
        this.$store.commit('setReload', false);
        //this.$store.commit('resetSelected')
        //this.$store.commit('multiple', false)
        //this.$store.commit('closeHovers')
  
        // Set loading to true and reset the error.
        this.setLoading(true);
        this.error = null;
  
        let url = this.$route.hash;
        if (url === '') {
          url = '/shared-drive';
        }
        else {
          url = url.slice(1);
        }
  
        try {
          let res;
          if (url[0] !== '/')
          {
            res = await api.fetchId(url, this.sortOrder);
            let nestedShares = await ibb.getSharedDrives();
            nestedShares = nestedShares.nodeList.filter(item => item.virtualParentHandle === res.handle && item.archived);
            if (nestedShares.length > 0) {
              for (let shared of nestedShares) {
                res.items.push(shared);
              }
            }
            this.$store.commit('updateRequest', res);
            if (res.isDir === false) {
              this.flag = false;
            } else {
              this.flag = true;
            }
  
            let breadcrumbs = [];
            let folder = res;
            while (folder.parentHandle || folder.virtualParentHandle) {
              breadcrumbs.unshift({ name: decodeURIComponent(folder.name), url: this.$route.path + '#' + folder.handle });
              if (folder.virtualParentHandle) {
                folder = await api.getParent(folder.virtualParentHandle);
              } else {
                folder = await api.getParent(folder.parentHandle);
              }
            }
            breadcrumbs.unshift({ name: decodeURIComponent(folder.name), url: this.$route.path + '#' + folder.handle });
            
            if (breadcrumbs.length > 3) {
              while (breadcrumbs.length !== 4) {
                breadcrumbs.shift();
              }
  
              breadcrumbs[0].name = '...';
            }
            this.bclist = breadcrumbs;
            document.title = res.name;
          }
          else
          {
            let sharedDrives = await ibb.getSharedDrives();
            sharedDrives = sharedDrives.nodeList.filter(item => !item.external && item.virtualParentHandle === '' && item.archived);
            res = {
              url: '/shdd',
              items: sharedDrives,
            };  
            this.$store.commit('updateRequest', res);
            this.bclist = [];
            document.title = 'Archived';
          }
        } catch (e) {
          this.error = e;
          this.$router.push({path: '/shared-drive/archived'});
        } finally {
          this.setLoading(false);
        }
      },
      keyEvent (event) {
        // Esc!
        if (event.keyCode === 27) {
          this.$store.commit('closeHovers');
  
          // If we're on a listing, unselect all
          // files and folders.
          if (this.isListing) {
            this.$store.commit('resetSelected');
          }
        }
  
        // Del!
        if (event.keyCode === 46) {
          if (this.isEditor || this.isSheets || this.isDocs ||
            !this.isFiles ||
            this.loading ||
            !this.user.perm.delete ||
            (this.isListing && this.selectedCount === 0) || this.isDelete) return;

          this.$store.commit('showHover', 'delete');
        }
  
        // F1!
        if (event.keyCode === 112) {
          event.preventDefault();
          this.$store.commit('showHover', 'help');
        }
  
        // F2!
        if (event.keyCode === 113) {
          if (this.isEditor || this.isSheets || this.isDocs ||
            !this.isFiles ||
            this.loading ||
            !this.user.perm.rename ||
            (this.isListing && this.selectedCount === 0) ||
            (this.isListing && this.selectedCount > 1) || this.isRename) return;

          this.$store.commit('showHover', 'rename');
        }

        // CTRL + S
        if (event.ctrlKey || event.metaKey) {
          if (this.isEditor || this.isSheets || this.isDocs) return;
  
          if (String.fromCharCode(event.which).toLowerCase() === 's') {
            event.preventDefault();
  
            if (this.req.kind !== 'editor') {
              document.getElementById('download-button').click();
            }
          }
        }
      },
      scroll () {
        if (this.req.kind !== 'listing' || this.$store.state.user.viewMode === 'mosaic') return;
  
        let top = 112 - window.scrollY;
  
        if (top < 64) {
          top = 64;
        }
  
        document.querySelector('#listing.list .item.header').style.top = top + 'px';
      },
      openSidebar () {
        this.$store.commit('showHover', 'sidebar');
      },
      openSearch () {
        this.$store.commit('showHover', 'search');
      },
      copy () {
        this.$store.commit('showHover', {prompt: 'share', message: this.accountInfo.link});
      }
    }
  };
  </script>
  